'use client'
import { useState } from 'react'
import AccordionItem from './accordion-item'
import styles from './styles.module.css'

export default function Accordion({item, type, shouldScroll, dict, activeIndex: externalActiveIndex, onActiveChange}) {
    const ideas = [
        {
            id: 1,
            title: dict.idea.acc_title_1,
            text: dict.idea.acc_text_1
        },
        {
            id: 2,
            title: dict.idea.acc_title_2,
            text: dict.idea.acc_text_2
        },
        {
            id: 3,
            title: dict.idea.acc_title_3,
            text: dict.idea.acc_text_3
        },
    ]

    const isControlled = externalActiveIndex !== undefined
    const [internalActiveIndex, setInternalActiveIndex] = useState(null)
    const activeIndex = isControlled ? externalActiveIndex : internalActiveIndex

    const handleItemClick = (id, e) => {
        e.stopPropagation()
        const newId = activeIndex === id ? null : id
        if (isControlled && onActiveChange) {
            onActiveChange(newId)
        } else {
            setInternalActiveIndex(newId)
        }
    }    
    let arr
    if (item) {
        arr = item
    } else {
        arr = ideas
    }
    return (
        <div className={styles.accordion__wrapper}>
            {arr.map(({id, title, text, text2}) => (
                <AccordionItem
                    type={type}
                    key={id}
                    number={id}
                    title={title}
                    text={text}
                    text2={text2}
                    shouldScroll={shouldScroll}
                    isOpen={activeIndex === id}
                    onClick={(e) => handleItemClick(id, e)}
                />
            ))}
        </div>
    )
}
